import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reposiciona o scroll no topo sempre que a rota muda.
 * Necessário porque o shell admin (Header/Sidebar) permanece montado entre páginas.
 */
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        if (document.documentElement) {
            document.documentElement.scrollTop = 0;
        }
        if (document.body) {
            document.body.scrollTop = 0;
        }
    }, [pathname]);

    return null;
}

export default ScrollToTop;
